/* eslint-disable @typescript-eslint/no-explicit-any */

import { IPrivacyService } from "../models/IPrivacyService";
export class DefaultPrivacyServiceController implements IPrivacyService {

    openSettings(): void {
        const elements = document.getElementsByTagName('csb-cookie-banner');

        if (elements && elements.length) {
            (elements[0] as any).open(1);
        }
    }

    getCookie(): string | undefined {
        const name = 'csb-cookie' + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return undefined;
    }

    isAllowed(cookieId: string): boolean {
        const csbCookie = this.getCookie();
        if (csbCookie) {
            const underscore = csbCookie.indexOf('_');
            const data = csbCookie.substr(underscore + 1);

            const values = data.split('&');
            const eventData: { name: string, allowed: boolean }[] = [];
            values.forEach(value => {
                const keyValue = value.split('_');
                eventData.push({ name: keyValue[0], allowed: keyValue[1] === 'true' });
            });
            const cookieData = eventData.find(x => x.name === cookieId);

            if (cookieData) {
                return cookieData.allowed;
            }
        }
        return false;
    }
}
export const defaultPrivacyService = new DefaultPrivacyServiceController();
